var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAssignDriver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 88,
    viewBox: "0 0 167 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M160 0c3.866 0 7 3.134 7 7s-3.134 7-7 7h-40c3.866 0 7 3.134 7 7s-3.134 7-7 7h22c3.866 0 7 3.134 7 7s-3.134 7-7 7h-10.174c-4.874 0-8.826 3.134-8.826 7 0 2.577 2 4.91 6 7 3.866 0 7 3.134 7 7s-3.134 7-7 7H46c-3.866 0-7-3.134-7-7s3.134-7 7-7H7c-3.866 0-7-3.134-7-7s3.134-7 7-7h40c3.866 0 7-3.134 7-7s-3.134-7-7-7H22c-3.866 0-7-3.134-7-7s3.134-7 7-7h40c-3.866 0-7-3.134-7-7s3.134-7 7-7h98zm0 28c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7 3.134-7 7-7z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.5,
    transform: "translate(0 1) translate(40 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "#F7F7F7",
    stroke: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#B4B4B4",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.128 52.738c1.759.325 3.548.494 5.368.506 14.635 0 26.5-11.864 26.5-26.5 0-14.635-11.865-26.5-26.5-26.5-3.76 0-7.337.783-10.576 2.195C10.29 4.892 5.677 9.244 2.892 14.686 1.04 18.303-.004 22.402-.004 26.744c0 3.94.86 7.68 2.402 11.04 1.101 2.4 2.55 4.607 4.282 6.556",
    transform: "rotate(88 26.5 33.749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.793 47.319c2.148 1.746 4.575 3.162 7.204 4.172",
    transform: "rotate(88 26.5 33.749)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#B4B4B4",
    d: "M58.5 57.5L67 66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    stroke: "#B4B4B4",
    d: "M69.457 63.61c1.24 0 2.481.474 3.427 1.42h0L83.97 76.116c.946.946 1.42 2.186 1.42 3.427 0 1.24-.474 2.48-1.42 3.427-.947.946-2.187 1.42-3.427 1.42-1.24 0-2.481-.474-3.427-1.42h0L66.03 71.884c-.946-.946-1.42-2.186-1.42-3.427 0-1.24.474-2.48 1.42-3.427.947-.946 2.187-1.42 3.427-1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M71 67L82 78"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M133.5 27h-17.176m24.176 0h-2.221m-11.103 7.777H119M32.5 48H15.324M9.5 48H5.279m31.897 8.777H29",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#B4B4B4",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2 18.2c5.028 0 9.1-4.072 9.1-9.1S23.228 0 18.2 0 9.1 4.072 9.1 9.1s4.072 9.1 9.1 9.1zm18.2 21.557V31.85c0-6.052-12.126-9.1-18.2-9.1S0 25.799 0 31.85v7.907",
    transform: "translate(0 1) translate(55 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssignDriver);
export default __webpack_public_path__ + "static/media/icon-assign-driver.f82361975da1c64cdbea0e01f297e7b6.svg";
export { ForwardRef as ReactComponent };